module.exports = __webpack_public_path__ + "img/imagen1.dab1e905.png";